/**
 * Processing Overlay Component
 * Shows progress during AI processing operations
 */
import React from 'react';
import { Wand2 } from 'lucide-react';

export function ProcessingOverlay({ 
  isProcessing, 
  message, 
  progress 
}) {
  if (!isProcessing) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center">
      <div className="bg-[var(--surface)] rounded-xl p-8 max-w-md w-full mx-4 text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-[var(--primary)]/20 flex items-center justify-center animate-pulse">
          <Wand2 className="text-[var(--primary)]" size={32} />
        </div>
        <h3 className="font-teko text-2xl mb-2">{message || 'Processing...'}</h3>
        <div className="w-full h-2 bg-[var(--background)] rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-[var(--primary)] to-purple-500 transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
        <p className="text-sm text-[var(--text-secondary)] mt-2">{progress}% complete</p>
      </div>
    </div>
  );
}

export default ProcessingOverlay;
